import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, of } from 'rxjs';
import * as Global from '../Model/CommanHttp';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BidderRegistrationService {

  constructor(private http: HttpClient, private router: Router) { }

  FillAllDDL(): Observable<any> {
    return this.http.get(`${Global.base_url}/BidderRegistration/FillAllDDL?Ind=1`, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('FillAllDDL')));
  }
  FillBidderDocuments(): Observable<any> {
    //   return this.http.get(`${Global.base_url}/BidderRegistration/BidderDocuments`, Global.httpContenttype).pipe(
    //     map(response => response), catchError(this.handleError<any>('FillAllDDL')));
    return this.http.get(Global.base_url + "/BidderRegistration/Documents", Global.httpContenttype)
  }
  GetOTP(mobno: string): Observable<any> {
    return this.http.get(`${Global.base_url}/BidderRegistration/GetOTP?MobileNo=` + mobno, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('GetOTP')));
  }
  CheckOTP(mobno: string, Password: string): Observable<any> {
    return this.http.get(`${Global.base_url}/BidderRegistration/CheckOTP?MobileNo=` + mobno + `&Password=` + Password, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('CheckOTP')));
  }

  SaveBidderRegistration(modelBidderReg): Observable<any> {
    // console.log(modelBidderReg);
    return this.http.post(`${Global.base_url}/BidderRegistration/SaveBidderReg`, modelBidderReg, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('SaveBidderReg')));
  }
  GetPymntResponse(GetTxnRegNo: number): Observable<any> {
    return this.http.get(`${Global.base_url}/BidderRegistration/PaymntRecptBind?TxnRegNo=` + GetTxnRegNo, Global.httpContenttype).pipe(
      map(response => response), catchError(this.handleError<any>('PaymntRecptBind')));
  }


// **************************Updation Start*****************
FillBidderInformation(Ind:number,FirmCd:number,AuctCtgid:number): Observable<any> {
  
  return this.http.get(`${Global.base_url}/BidderRegistration/FillBidderInformation?Ind=` + Ind + `&FirmCd=` + FirmCd+`&AuctCtgid=`+AuctCtgid, Global.httpContenttype).pipe(
    map(response => response), catchError(this.handleError<any>('FillBidderInformation')));
}
UpdateBidderRegistration(modelBidderReg): Observable<any> {
  // console.log(modelBidderReg);
   return this.http.post(`${Global.base_url}/BidderRegistration/UpdateBidderReg`, modelBidderReg, Global.httpContenttype).pipe(
     map(response => response), catchError(this.handleError<any>('UpdateBidderReg')));
 }


  //For Error Handling
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}



// FilterMasterForBSReg(Ind, StateCd, ZoneCd, DistrictCd, CityCode, brachcode): Observable<any> {
//   return this.http.get(`${Global.base_url}/BankSakhi/FilterMasterForBSReg?Ind=` + Ind + `&StateCd=` + StateCd + `&ZoneCd=` + ZoneCd
//     + `&DistrictCd=` + DistrictCd + `&CityCode=` + CityCode + `&brachcode=` + brachcode, Global.httpContenttype).pipe(
//       map(response => response), catchError(this.handleError<any>('FilterMasterForBSReg')));
// }